import React from "react";
import styles from "../DressingChangeFrequency.module.scss";
import { PERIOD_OPTIONS, clampInt } from "../utils/scheduleUtils";
import type { Schedule, SchedulePatch, SchedulePeriod } from "../types";

interface TimesPanelProps {
  schedule: Schedule;
  onChange: (patch: SchedulePatch) => void;
}

export const TimesPanel: React.FC<TimesPanelProps> = ({ schedule, onChange }) => (
  <div className={styles.panel}>
    <div className={styles.stepper}>
      <button
        type="button"
        aria-label="Decrease"
        className={styles.stepper_btn}
        onClick={() => onChange({ times: Math.max(1, schedule.times - 1) })}
      >
        {"\u2212"}
      </button>
      <input
        type="number"
        min="1"
        max="24"
        aria-label="Number of changes"
        className={styles.stepper_input}
        value={schedule.times}
        onChange={(e) => onChange({ times: clampInt(e.target.value, 1, 24) })}
      />
      <button
        type="button"
        aria-label="Increase"
        className={styles.stepper_btn}
        onClick={() => onChange({ times: Math.min(24, schedule.times + 1) })}
      >
        +
      </button>
    </div>
    <span className={styles.panel_inline_label}>times per</span>
    <div role="group" aria-label="Period" className={styles.chip_group}>
      {PERIOD_OPTIONS.map((p) => {
        const on = schedule.period === p;
        return (
          <button
            key={p}
            type="button"
            className={`${styles.chip} ${on ? styles.chip_on : ""}`}
            aria-pressed={on}
            onClick={() => onChange({ period: p as SchedulePeriod })}
          >
            {p.charAt(0).toUpperCase() + p.slice(1)}
          </button>
        );
      })}
    </div>
  </div>
);
